import React from "react";
import {
	IndicatorButton,
	IndicatorType,
} from "src/components/buttons/IndicatorButton";
import { NeurapulseConfigDialog } from "./NeurapulseConfigDialog";
import styles from "./NeurapulseApiKeyButton.module.css";
import neurapulseLogo from "src/assets/images/neurapulse/neurapulse-colored 1.png";
import { clsx } from "clsx";
import { Tooltip } from "antd";

type NeurapulseApiKeyButtonProps = {
	// Add any additional props here if needed in the future
	dataset: DatasetDTO;
	refreshDataset: () => Promise<void>;
	disabled?: boolean;
};
export const NeurapulseApiKeyButton = ({
	dataset,
	refreshDataset: refreshDatasetAsync,
	disabled = true,
}: Readonly<NeurapulseApiKeyButtonProps>) => {
	const [isDialogVisible, setIsDialogVisible] = React.useState(false);
	const neurapulseProjectIdSet = dataset != null && dataset.neurapulseProjectId;
	const indicatorType: IndicatorType = neurapulseProjectIdSet
		? "check"
		: "ping";
	const handleClose = async (update: boolean) => {
		setIsDialogVisible(false);
		if (update) {
			await refreshDatasetAsync();
		}
	};

	const blerb = (
		<div>
			Vitals has evolved to deliver greater scalability and efficiency for your team. To learn more, contact{" "}
			<a href="mailto:neurapulse@impirica.tech" style={{ color: "lightblue" }}>
				neurapulse@impirica.tech
			</a>{" "}
			or your administrator.
		</div>
	);

	if (!dataset || !dataset.id || !dataset.organizationId) {
		return null;
	}
	return (
		<>
			<Tooltip
				title={disabled ? blerb : undefined}
				trigger={disabled ? "click" : "hover"}
				placement="leftBottom"
			>
				<div>
					<IndicatorButton
						indicator={indicatorType}
						{...(!disabled ? { onClick: () => setIsDialogVisible(true) } : {})}
					>
						<img
							src={neurapulseLogo}
							alt="Neurapulse Logo"
							className={clsx(styles.neurapulseLogo)}
						/>
					</IndicatorButton>
				</div>
			</Tooltip>
			<NeurapulseConfigDialog
				dataset={dataset}
				visible={isDialogVisible}
				onClose={handleClose}
			/>
		</>
	);
};
